import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { agreementsManager, type IAgreement } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { type IMostRecentCDA } from './types';

const AGREEMENT_MODULE = 'agreement';

const dataObjectModule = getDataObjectsModule<IAgreement>(agreementsManager, 3);
const searchModule = getSearchModule<IAgreement>(agreementsManager);

const state: IMostRecentCDA = {
    mostRecentCDA: new Map()
};

const agreementModuleInstance = merge<unknown>(dataObjectModule, searchModule, { state, actions, mutations, getters });
store.registerModule(AGREEMENT_MODULE, agreementModuleInstance);

export { AGREEMENT_MODULE };
